export default __webpack_public_path__ + "images/8043d47237dc3599f33634e2e2361836.png";